<template>
  <div v-if="symptoms.length > 0">
    <div class="info--text text-uppercase my-3 mt-2">
      {{ generateMessage('requests.details.titles.specificSymptoms') }}
    </div>
    <div class="d-flex flex-wrap">
      <v-col cols="12" md="6">
        <div class="font-weight-bold">Types de symptômes spécifiques</div>
        <v-data-table
          dense
          :loading="symptomsLoading"
          hide-default-footer
          fixed-header
          height="300"
          disable-sort
          disable-pagination
          :items="symptoms"
          :headers="symptomsHeaders"
          class="secondarybackground striped-table clickable ma-2"
        >
          <template v-slot:item="{ item }">
            <tr
              :class="{ selected: item.code === typeCode }"
              @click="selectType(item)"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.intervention_contract_period }}</td>
              <td>{{ item.category_name }}</td>
              <td>{{ item.sub_category_name }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" md="6">
        <div class="font-weight-bold">Qualification de symptôme</div>
        <v-data-table
          dense
          :loading="qualificationsLoading"
          hide-default-footer
          fixed-header
          height="300"
          disable-sort
          disable-pagination
          :items="typeCode ? qualifications : []"
          :headers="qualificationsHeaders"
          class="secondarybackground striped-table ma-2"
        />
      </v-col>
    </div>
  </div>
</template>

<script>
import { generateMessage } from '@/utils/i18n';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PropertySpecificSymptoms',
  computed: {
    ...mapGetters({
      symptoms: 'properties/types/items',
      qualifications: 'properties/qualifications/items',
      symptomsLoading: 'properties/types/isLoadingItems',
      qualificationsLoading: 'properties/qualifications/isLoadingItems',
    }),
  },
  methods: {
    ...mapActions({
      setFilterAttributeSymptomQualif:
        'properties/qualifications/setFilterAttribute',
    }),
    generateMessage,
    selectType(item) {
      this.typeCode = item.code;
      this.setFilterAttributeSymptomQualif({
        attribute: 'work_order_group_type_code',
        values: [item.code],
      });
    },
  },
  data: () => ({
    typeCode: null,
    symptomsHeaders: [
      { text: 'Symptôme', value: 'name' },
      { text: 'Delai ITV (en H)', value: 'request_contract_period' },
      { text: 'Catégorie', value: 'category_name' },
      { text: 'Sous-Catégorie', value: 'sub_category_name' },
      { text: '', value: 'selected' },
    ].map((item) => {
      return { ...item, class: 'secondarybackground' };
    }),
    qualificationsHeaders: [
      { text: 'Qualification', value: 'name' },
      { text: 'Catégorie', value: 'category_name' },
      { text: 'Sous-Catégorie', value: 'sub_category_name' },
    ].map((item) => {
      return { ...item, class: 'secondarybackground' };
    }),
  }),
};
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
</style>
